import { DIALOG_DONE } from '@/components/dialogs'
import { LogOutService } from '@/services/auth/common/logOutService'
export default {
  data () {
    return {
      eventsList: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
      warningTimer: null,
      logoutTimer: null
    }
  },

  methods: {
    trackUserActivness () {
      this.eventsList.forEach((event) => {
        window.addEventListener(event, this.resetTimer)
      }, this)

      this.setTimers()
    },

    setTimers () {
      this.warningTimer = setTimeout(this.displayWarningMessage, 12 * 60 * 1000)
      this.logoutTimer = setTimeout(this.logoutUser, 15 * 60 * 1000)
    },

    logoutUser () {
      LogOutService.logoutApp()
    },

    resetTimer () {
      clearTimeout(this.warningTimer)
      clearTimeout(this.logoutTimer)
      this.setTimers()
    },

    displayWarningMessage () {
      DIALOG_DONE.props.text = this.$i18n.t('dialogs.text.logoutWarning')
      this.$store.dispatch('ui/openDialog', Object.assign({}, DIALOG_DONE, {
        props: {
          ...DIALOG_DONE.props,
          buttonActionAffirmative: () => {
            this.$store.dispatch('ui/closeDialog')
          }
        }
      }))
    }
  }
}
